import { SET_QUERY_LOCALE, SET_LOCALE } from './locale-actions';

type State = { current: string; query: string | null };

export default function locale(state: State = { current: 'en', query: null }, action: any): State {
  switch (action.type) {
    case SET_LOCALE:
      return { ...state, current: action.payload };
    case SET_QUERY_LOCALE:
      return { ...state, query: action.payload };
    default:
      return state;
  }
}
